// extracted by mini-css-extract-plugin
module.exports = {"CommunityGrid":"CommunityGrid_CommunityGrid__k9oMo","SmallerGrid":"CommunityGrid_SmallerGrid__pmoiA"};